import ButtonsGroup from "@components/ButtonsGroup";
import Dialog from "@components/Dialog";
import Input from "@components/Input";
import SizedBox from "@components/SizedBox";
import Text from "@components/Text";
import styled from "@emotion/styled";
import { Column } from "@src/components/Flex";
import Scrollbar from "@src/components/Scrollbar";
import Balance from "@src/entities/Balance";
import useOnClickOutside from "@src/hooks/useOnClickOutside";
import { observer } from "mobx-react-lite";
import React, { useRef, useState } from "react";
import TokenInfo from "./TokenInfo";

interface IProps {
  onClose: () => void;
  balances: Balance[];
  onSelect: (assetId: string) => void;
  visible: boolean;
  selectedTokenId?: string;
}

const tokenCategories = [
  "All",
  // "Global",
  "Stables",
  "Common",
  "PZ LP",
  "Memes"
  // "Waves DeFi",
  // "Waves Ducks",
];

export enum tokenCategoriesEnum {
  all = 0,
  // global = 1,
  // stable = 2,
  // ducks = 4,
  stable = 1,
  common = 2,
  pz = 3,
  // defi = 4,
  meme = 4
}

const Scroll = styled.div`
  display: flex;
  margin: 0 -24px;
  padding: 0 24px 16px 24px;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }

  border-bottom: 1px solid ${({ theme }) => theme.colors.primary100};
`;
const TokenSelectModal: React.FC<IProps> = ({ onClose, balances, onSelect, visible, selectedTokenId }) => {
  const [searchValue, setSearchValue] = useState<string>("");
  const [activeFilter, setActiveFilter] = useState<number>(0);
  const handleSearch = (event: any) => {
    setSearchValue(event.target.value);
  };
  const ref = useRef(null!);
  useOnClickOutside(ref, onClose);

  const handleTokenSelect = (assetId: string) => {
    onSelect(assetId);
    setActiveFilter(0);
    onClose();
  };
  const filteredTokens = balances
    .filter((v) => {
      if (!v || !v.symbol || !v.name) {
        return false;
      }
      return (
        v.symbol.toLowerCase().includes(searchValue.toLowerCase()) ||
        v.name.toLowerCase().includes(searchValue.toLowerCase())
      );
    })
    .filter((balance) => {
      if (activeFilter === 0) return true;
      return balance.category?.includes(tokenCategoriesEnum[activeFilter]);
    });

  return (
    <Dialog
      visible={visible}
      style={{ maxWidth: 360 }}
      styles={{
        body: { minHeight: 440 }
      }}
      onClose={() => {
        setActiveFilter(0);
        onClose();
      }}
      title="Select a token"
    >
      <Input icon="search" value={searchValue} onChange={handleSearch} placeholder="Search by name or ticker…" />
      <SizedBox height={16} />

      <Scroll>
        <ButtonsGroup values={tokenCategories} active={activeFilter} onClick={(v) => setActiveFilter(v)} />
      </Scroll>
      <SizedBox height={32} />
      <Scrollbar style={{ margin: -24 }}>
        <Column crossAxisSize="max" style={{ maxHeight: 352 }}>
          {filteredTokens && filteredTokens.length > 0 ? (
            filteredTokens.map((t) => {
              const disabled = selectedTokenId === t.assetId;
              return (
                <TokenInfo
                  hidden={disabled}
                  style={{ position: "relative" }}
                  withClickLogic
                  onClick={!disabled ? () => handleTokenSelect(t.assetId) : () => null}
                  key={t.assetId}
                  token={t}
                />
              );
            })
          ) : (
            <Text style={{ padding: "10px 24px" }}>No tokens found</Text>
          )}
          <SizedBox height={32} width={16} />
        </Column>
      </Scrollbar>
    </Dialog>
  );
};
export default observer(TokenSelectModal);
